import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultError: {
		id: 'servicedesk.automation.summary.summary.page-error.default-error',
		defaultMessage: 'We encountered a problem. Please try again later.',
		description: '',
	},
	reload: {
		id: 'servicedesk.automation.summary.summary.page-error.reload',
		defaultMessage: 'Reload',
		description: '',
	},
});
